'use strict';

const breadcrumbsTokens = (theme) => ({
    breadcrumbsFontSize: theme.typography.fontSize.xs,
    breadcrumbsFontFamily: theme.typography.fontFamily.regular,
    breadcrumbsFontWeight: theme.typography.fontWeight.semibold,
    breadcrumbsLineHeight: theme.typography.lineHeight.xs,
    breadcrumbsPaddingY: theme.space.component.y.xs,
    breadcrumbsBreadcrumbColor: theme.colors.body.text,
    breadcrumbsBreadcrumbBackground: theme.colors.body.background,
    breadcrumbsBreadcrumbPaddingX: theme.space.component.x.xs,
    breadcrumbsBreadcrumbBorderRadius: theme.radiuses.m,
    breadcrumbsBreadcrumbHoverBackground: theme.colors.primary.alpha,
    breadcrumbsBreadcrumbHoverColor: theme.colors.body.text,
    breadcrumbsBreadcrumbFocusBackground: theme.colors.primary.alpha,
    breadcrumbsBreadcrumbFocusColor: theme.colors.primary.normal,
});

exports.breadcrumbsTokens = breadcrumbsTokens;
//# sourceMappingURL=breadcrumbs.js.map
